<template>
  <div class="outbox">
    <div class="hearder_out">
      <div class="contact">
        <div style="width: 50px;height: 50px;margin: 30px auto;">
          <img src="../../static/index/contact.png" style="width: 100%;height: 100%;" alt="">
        </div>
        <div style="font-size: 10px;">客服热线</div>
        <div style="margin: 10px 0;color: black;font-weight: bolder; font-size: 16px;">18650291825</div>
        <div class="contact-us" @click="open">联系我们</div>
      </div>
    </div>
    <article class="scroller">
      <section>
      <div class="hearder">
        <div class="h_l">
          <img src="../../static/index/logo.png" style="width: 80px;height: 60px;" />
          <div>卟简单 更实用</div>
        </div>
        <div class="h_r">
          <template v-if="isLogin">
            <el-menu mode="horizontal" text-color="#000" active-text-color="#000">
              <el-submenu index="2" class="submenu">
                <template slot="title"><el-avatar size="small" :src="userData.avatar"
                    style="margin-right: 6px;"></el-avatar></template>
                <template slot="title">{{ userData.account }}</template>
                <el-menu-item v-if="ishavaStore" @click="getPermissionList" index="2-1">进入店铺</el-menu-item>
                <el-menu-item @click="gochooseStore" index="2-2">切换店铺</el-menu-item>
                <el-menu-item @click="exit()" index="2-5">退出登录</el-menu-item>
              </el-submenu>
            </el-menu>
          </template>
          <template v-else>
            <span>首页</span>
            <el-dropdown>
              <span>
                产品和服务<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item class="drop-item">
                  <div style="height: 45px;width: 45px;margin-top: 10px;" @click="scrollbox">
                    <img src="../../static/icon1.png" style="width: 100%;height: 100%;" />
                  </div>
                  <div class="item-text" @click="scrollbox">
                    <p style="color: black;font-size: 20px;margin: 0;">全渠道融合版</p>
                    结合线上线下一体化经营
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="drop-item">
                  <div style="height: 45px;width: 45px;margin-top: 10px;" @click="scrollbox">
                    <img src="../../static/icon2.png" style="width: 100%;height: 100%;" />
                  </div>
                  <div class="item-text" @click="scrollbox">
                    <p style="color: black;font-size: 20px;margin: 0;">电商分销版</p>
                    分销微盟、淘宝等多个平台
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="drop-item">
                  <div style="height: 45px;width: 45px;margin-top: 10px;" @click="scrollbox">
                    <img src="../../static/icon3.png" style="width: 100%;height: 100%;" />
                  </div>
                  <div class="item-text" @click="scrollbox">
                    <p style="color: black;font-size: 20px;margin: 0;">线下批发版</p>
                    让门店经营管理更高效
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="drop-item">
                  <div style="height: 45px;width: 45px;margin-top: 10px;" @click="scrollbox">
                    <img src="../../static/icon4.png" style="width: 100%;height: 100%;" />
                  </div>
                  <div class="item-text" @click="scrollbox">
                    <p style="color: black;font-size: 20px;margin: 0;">微信微商城</p>
                    以微信作为入口的电商系统
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span @click="open">合作加盟</span>
            <span @click="aboutUs">关于我们</span>
            <div @click="openLogin('register')" class="resgiter">免费注册</div>
            <span @click="openLogin('accountLogin')" class="login">登录</span>
          </template>
        </div>
      </div>
        <div style="min-width: 1200px;height: 710px;">
          <el-carousel height="710px">
            <el-carousel-item>
              <img src="../../static/index/a1.jpg" style="width: 100%;height: 100%;" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../static/index/a2.jpg" style="width: 100%;height: 100%;" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../static/index/a3.jpg" style="width: 100%;height: 100%;" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>
      <section>
        <!-- 了解 -->
        <div class="reaster">
          <div class="out_tilte">了解我们的产品</div>
          <div class="out_tilte_s">多种领域，打造开放共赢、集成创新的产业</div>
          <div class="typebox">
            <div class="tb_once">
              <div class="hr">
                <img src="../../static/icon1.png" />全渠道融合版
              </div>
              <h1>全渠道结合线上线下一体化经营</h1>
              <p>
                全渠道融合版主要针对b2b、工厂、商贸、批发、电商、全渠道商品处理、订单处理、供应关系处理、会员客户处理系统实现商品一件平台铺货、一件分销铺货
                、订单发货、商品隐藏、货源市场供应、客户层级配置、一客一价、信用支付、单批混批等适合线上线下b2b全域营销。
              </p>
            </div>
            <div class="tb_once">
              <div class="hr">
                <img src="../../static/icon2.png" />线下批发版
              </div>
              <h1>让门店经营管理更高效</h1>
              <p>
                线下批发版实现从商品、采购、销售、门店、财务等业务的闭环管理，统一管理线下门店等多渠道的商品、价格、库存和订单。通过代客下单，代客售后，混批模式，信用账期等有效的帮助客户处理订单，从而提高复购率。
              </p>
            </div>
          </div>
          <div class="typebox mb">
            <div class="tb_once">
              <div class="hr">
                <img src="../../static/icon3.png" />电商分销版
              </div>
              <h1>电商版可以分销微盟、淘宝等多个平台</h1>
              <p>
                电商版可以分销微盟、淘宝等多个平台，全渠道商品处理、订单处理、供应关系处理、会员客户处理系统实现商品一件平台铺货、一件分销铺货、订单发货、商品隐藏、货源市场供应、客户层级配置、一客一价、信用支付、单批混批等营销。
              </p>
            </div>
            <div class="tb_once">
              <div class="hr">
                <img src="../../static/icon4.png" />微信微商城
              </div>
              <h1>以微信作为入口的电商系统</h1>
              <p>
                以微信作为入口的电商系统，使得商品营销更具传播性，微商城主要功能有一客一价、单批、混批、在线支付、信用账期、一键下单、订单售后、隐藏商品等功能。用户可以轻松分享购买经验和产品评价。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div style="height:950px; background-color:#edf1f8;" ref="targetBox">
          <div class="out_tilte">版本与应用</div>
          <div class="custom-tabs-parent" style="margin-top: 30px;">
            <el-tabs class="custom-tabs" v-model="activeName">
              <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab.label" :name="tab.name" class="tab">
                <div style="display: flex; width: 100%;">
                  <div class="big-img" :style="backgroundStyle">
                    <div class="img-box">
                      <!-- 这里假设每个 tab 都有相同的图片，或者你可以根据 tab 动态改变图片 -->
                      <img :src="tab.imgUrl" class="all-img" alt="">
                    </div>
                  </div>
                  <div style="margin-left: 50px;">
                    <h1>{{ tab.label }}</h1>
                    <div class="out_tilte_s" style="text-align: left;padding-bottom: 0px;">
                      {{ tab.content }}
                    </div>
                    <ul style="width: 750px;flex-wrap: wrap;display: flex;list-style: none; margin-right: 30px;">
                      <li class="all-li" v-for="(item, itemIndex) in tab.items" :key="itemIndex">{{ item }}</li>
                    </ul>
                    <button class="btn" :style="{ backgroundColor: currentTabBgColor }"
                      @click="open">了解更多&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;></button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </section>
      <section>
        <div style="height:900px; background-color: #fff;">
          <div class="out_tilte">功能与应用</div>
          <div class="all-tabs-parent">
            <el-tabs class="all-tabs" v-model="activeSenconde">
              <el-tab-pane class="tab" v-for="(three, index) in third" :key="index" :label="three.label"
                :name="three.name">
                <div style="display: flex; width: 100%;">
                  <div class="img-box-two">
                    <img :src="three.imgUrl" style="width: 100%;height: 100%;">
                  </div>
                  <div style="margin-top: 160px;">
                    <h1>{{ three.label }}</h1>
                    <div class="out_tilte_s" style="text-align: left;padding-bottom: 0px;width: 480px;">
                      {{ three.content }}
                    </div>
                    <div style="margin-top: 80px;">
                      <button class="btn-left" @click="open">立刻咨询</button>
                      <button class="btn-right" @click="open">申请试用</button>
                    </div>
                  </div>
                </div>

              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </section>
      <section>
        <div class="hzbox">
          <div class="out_tilte">合作企业</div>
          <div class="out_tilte_s">携手各类服务商合作伙伴 共筑行业生态</div>
          <div class="hzbox_inner">
            <img src="../../static/hz/1.png" />
            <img src="../../static/hz/2.png" />
            <img src="../../static/hz/3.png" />
            <img src="../../static/hz/4.png" />
            <img src="../../static/hz/5.png" />
            <img src="../../static/hz/6.png" />
            <img src="../../static/hz/7.png" />
            <img src="../../static/hz/8.png" />
          </div>
        </div>
        <div class="joinbox">
          <div class="joinbox_inner">
            <h1>期待与您合作</h1>
            <p>申请入驻 > 对接教学 > 上线使用</p>
          </div>
          <div class="jobox-joinus" @click="open">
            加入我们
          </div>
        </div>
      </section>
      <section>
        <div class="footer">
          <div class="footer_inner">
            <div class="fl_1">
              <div class="h_l">
                <img src="../../static/index/logo.png" style="width: 60px;height: 40px;" />
                <div>
                  <div style="margin-bottom: 0;font-size: 20px;">卟云系统</div>
                  <div style="font-size: 8px;margin-left: 10px;">BU YUN XI TONG</div>
                </div>
              </div>
              <div style=" color: #787878;">服务电话：18650291825</div>
              <div style=" color: #787878;">邮箱：0002@xt1986.com</div>
              <div style=" color: #787878;">备案：闽ICP备2023007218号-1</div>
            </div>
            <div class="fl_2">
              <div>产品与服务</div>
              <ul style="list-style: none;">
                <li  @click="scrollbox">全渠道融合版</li>
                <li  @click="scrollbox">线下批发版</li>
                <li  @click="scrollbox">电商分销版</li>
                <li  @click="scrollbox">微信微商城</li>
              </ul>
            </div>
            <div class="fl_2">
              <div>热门推荐</div>
              <ul style="list-style: none;">
                <li  @click="open">建网站</li>
                <li  @click="open">建商城</li>
                <li  @click="open">建小程序</li>
                <li  @click="open">联系我们</li>
              </ul>
            </div>
            <div class="fl_3">
              <div style="width: 100px;height: 100px;">
                <img src="../../static/index/wx.jpg" style="width: 100%; height: 100%;" alt="">
              </div>
              <p style="text-align: center;width: 100px;">联系我们</p>
            </div>
          </div>
        </div>
      </section>
    </article>
    <div class="login-wrap_out" :class="{ 'login-wrap_out_c': showPop }">
      <div @click.stop class="login-wrap">
        <i @click="showPop = false" class="el-icon-close"></i>
        <h3 class="title">商户平台</h3>
        <el-tabs v-model="status" style="margin-bottom: 10px;" @tab-click="handleClick">
          <el-tab-pane label="账号登录" name="accountLogin"></el-tab-pane>
          <el-tab-pane label="手机号登录" name="mobileLogin"></el-tab-pane>
          <el-tab-pane label="手机号注册" name="register"></el-tab-pane>
        </el-tabs>
        <el-form class="formCls" :class="{ 'formCls_o': showAnimate }" label-position="left" :model="ruleForm"
          :rules="rules" ref="ruleForm" label-width="0px">
          <template v-if="status == 'accountLogin'">
            <el-form-item prop="account">
              <el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"
                show-password></el-input>
            </el-form-item>
          </template>
          <template v-else-if="status == 'mobileLogin'">
            <el-form-item prop="mobile">
              <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <div style="display: flex;align-items: center;width: 100%;">
              <el-form-item prop="code" style="flex: 1;">
                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
              <el-button @click="getyanzhengma" type="primary" style="margin-bottom: 22px;margin-left: 10px;">{{
                yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
            </div>
          </template>
          <template v-else>
            <el-form-item prop="mobile">
              <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <div style="display: flex;align-items: center;width: 100%;">
              <el-form-item prop="code" style="flex: 1;">
                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
              <el-button @click="getyanzhengma" type="primary" style="margin-bottom: 22px;margin-left: 10px;">{{
                yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
            </div>
            <el-form-item prop="pwd_r">
              <el-input v-model="ruleForm.pwd_r" placeholder="密码"></el-input>
            </el-form-item>
          </template>
          <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">{{ status
              ==
              'register' ? '注册' : '登录' }}
            </el-button>
          </el-form-item>
          <img src="" alt="">
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import router,{resetRouter} from '@/router';
export default {
  name: 'login',
  data() {
    return {
      activeSenconde: '1',
      activeName: 'first',
      logining: false,
      showPop: false,
      userData: null,
      isLogin: false,
      ishavaStore: false,
      swiperHeight: '0px',
      bannerList: [],
      status: 'accountLogin',
      showAnimate: false,
      yanzhengma: '获取验证码',
      timer: null,
      ruleForm: {
        account: '',
        password: '',
        mobile: '',
        code: '',
        pwd_r: ''
      },
      rules: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        pwd_r: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
      },
      tabs: [
        {
          label: '全渠道融合版',
          name: 'first',
          items: ['混批功能', '铺货功能', '隐藏商品', '一键下单', '一客一价', '货源市场', '批发模式', '一件代发', '订单发货', '订单售后', '在线支付', '一键供应', '代客下单', '代客售审', '一键分销', '一键批发', '信用账期', '微盟', '淘宝', '京东'],
          imgUrl: require('../../static/index/one.jpeg'),
          content: '全渠道结合线上线下一体化经营',
          activeTabBgColor: '#42d0fb'
        },
        {
          label: '线下批发版',
          name: 'second',
          items: ['混批功能', '铺货功能', '隐藏商品', '一键下单', '一客一价', '货源市场', '批发模式', '一件代发', '订单发货', '订单售后', '在线支付', '一键供应', '代客下单', '代客售审', '一键分销', '一键批发', '信用账期', '员工账号', '充值套餐', '会员等级'],
          imgUrl: require('../../static/index/two.jpeg'),
          content: '让门店经营管理更高效',
          activeTabBgColor: '#2e89f9'
        },
        {
          label: '电商分销版',
          name: 'third',
          items: ['混批功能', '铺货功能', '隐藏商品', '一键下单', '一客一价', '货源市场', '批发模式', '一件代发', '订单发货', '订单售后', '在线支付', '一键供应', '代客下单', '代客售审', '一键分销', '一键批发', '信用账期', '微盟', '淘宝', '京东'],
          imgUrl: require('../../static/index/three.jpeg'),
          content: '电商版可以分销微盟，淘宝等多个平台',
          activeTabBgColor: "#fe9c52"
        },
        {
          label: '微信微商城',
          name: 'four',
          items: ['水果生鲜', '食品饮料', '服装', '数码电器', '餐饮服务', '日用百货', '美容护肤', '母婴玩具', '生活服务', '空白横板', '茶叶酒类', '安防监控', '工商法务', '仪器器材', '商场便利', '宠物用品', '医疗健康', '五金建材', '运动户外', '家纺家居'],
          imgUrl: require('../../static/index/four.jpeg'),
          content: '以微信为入口的电商系统',
          activeTabBgColor: "#34d67e"
        }
      ],
      third: [
        { label: '货源市场', name: '1', imgUrl: require('../../static/ALL/1.png'), content: '公司与多家零售商和代理商建立了长期稳定的合作关系。海量货源，一键分销货品。' },
        { label: '铺货功能', name: '2', imgUrl: require('../../static/ALL/2.png'), content: '一键铺货到多个店铺，无货源一件代发，批量发货。' },
        { label: '商品隐藏', name: '3', imgUrl: require('../../static/ALL/3.png'), content: '卖家可以选择将自己的宝贝隐藏起来，申请登入之后其他人才能查看详情。' },
        { label: '一键下单', name: '4', imgUrl: require('../../static/ALL/4.png'), content: '多规格，多型号，不同批发数量，一键下单方便快捷。' },
        { label: '批发模式', name: '5', imgUrl: require('../../static/ALL/5.png'), content: '可以对商品进行批发。' },
        { label: '一客一价', name: '6', imgUrl: require('../../static/ALL/6.png'), content: '根据客户的身份等级设置专属协议价。' },
        { label: '一件代发', name: '7', imgUrl: require('../../static/ALL/7.png'), content: '海量货源一件代发，支持多平台批量处理，一键上传商品。' },
        { label: '订单发货', name: '8', imgUrl: require('../../static/ALL/8.png'), content: '下单，订单备注，订单发货多渠道发货。' },
        { label: '在线支付', name: '9', imgUrl: require('../../static/ALL/9.png'), content: '支持在线支付，记账，线下支付，多种支付方式。' },
        { label: '混批功能', name: '10', imgUrl: require('../../static/ALL/10.png'), content: '可以混合不同品牌或不同款式的商品进行批发' },
      ],
      activeTabBgColor: '#42d0fb', // 默认的背景色，与第一个标签的背景色相同
      routerList:[]
    }
  },
  computed: {
    currentTabBgColor() {
      const activeTab = this.tabs.find(tab => tab.name === this.activeName);
      return activeTab ? activeTab.activeTabBgColor : '#42d0fb'; // 如果没有找到激活的标签，则使用默认色
    },
    backgroundStyle() {
      return {
        backgroundImage: `linear-gradient(to bottom, ${this.currentTabBgColor}, ${this.currentTabBgColor})`,
      };
    },
  },
  created() {
    this.swiperHeight = 570 * document.body.offsetWidth / 1920 + 'px'
    window.addEventListener('resize', function () {
      this.swiperHeight = 570 * document.body.offsetWidth / 1920 + 'px'
    })
    if (localStorage.getItem('userdata_shop')) {
      this.userData = JSON.parse(localStorage.getItem('userdata_shop'))
      this.isLogin = true
    } else {
      this.isLogin = false
    }
    if (localStorage.getItem('ishavaStore') == 'true') {
      this.ishavaStore = true
    } else {
      this.ishavaStore = false
    }
    var that = this
    setTimeout(function () {
      that.showAnimate = true
    }, 500)
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 关于我们
    aboutUs() {
      this.$router.push({
        path: '/about'
      })
    },
    // 合作加盟
    open() {
      this.$alert(
        `<div style="text-align: center;">
            <img src="./static/index/wx.jpg" alt="" style="width: 350px;height:350px;">
            <h6>二维码如果过期，请联系客服咨询，并提醒
          </div>`,
        '扫描二维码，即可了解',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
        }
      )
    },
    // 滚动到指定盒子
    scrollbox() {
      const box = this.$refs.targetBox;
      if (box) {
        box.scrollIntoView({ behavior: 'smooth' });
      };
    },
    // 获取验证码
    getyanzhengma() {
      if (this.ruleForm.mobile) {
        if (this.yanzhengma == '获取验证码') {
          this.yanzhengma = 59
          this.timer = setInterval(() => {
            if (this.yanzhengma <= 0) {
              this.yanzhengma = '获取验证码'
              clearInterval(this.timer)
            } else {
              this.yanzhengma = this.yanzhengma - 1
            }
          }, 1000)
          this.$get(this.$api.sendsms, {
            mobile: this.ruleForm.mobile
          }).then(res => {
            if (res.status == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
          })
        }
      } else {
        this.$message.error('请输入手机号');
      }
    },
    // 进入店铺
    goStore() {
      let result=JSON.parse(localStorage.getItem('menuList')).filter(item => {
        return item.rule_id==107
      })
      let path=result[0].child[0]
      if(path.type=='menu'){
        path=result[0].child[0].path
      }else{
        path=result[0].child[0].child[0].path
      }
      this.$router.push({
        path: path
      })
    },
    // 切换店铺
    gochooseStore() {
      this.$router.push({
        path: '/chooseStore'
      })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        localStorage.setItem('logintoken_shop', '')
        localStorage.setItem('userdata_shop', '')
        localStorage.setItem('ishavaStore', '')
        this.userData = null
        this.isLogin = false
        this.$message({
          type: 'success',
          message: '已退出登录!'
        })
      })
    },
    openLogin(type) {
      this.status = type
      this.showPop = true
    },
    handleClick() {
      this.ruleForm.account = ''
      this.ruleForm.password = ''
      this.ruleForm.mobile = ''
      this.ruleForm.code = ''
      this.ruleForm.pwd_r = ''
      clearInterval(this.timer)
      this.yanzhengma = '获取验证码'
      this.$refs['ruleForm'].resetFields();
      this.showAnimate = false
      var that = this
      setTimeout(function () {
        that.showAnimate = true
      }, 500)
    },
    // 获取当前帐号的权限ids
    getRuleIds(){
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(res.data))
          this.goStore()
        }
      })
    },
    // 处理路由集合
    handlerRouters(list){
      list.forEach(item => {
        if(item.component&&item.path){
          this.routerList.push({path:item.path,name:item.title,keepalive:item.keepalive,'component':() => import(`@/views${item.component}`),meta:{requireAuth: true,keepalive:item.keepalive}})
        }
        if(item.child.length>0){
          this.handlerRouters(item.child)
        }
      })
    },
    // 获取权限列表
    getPermissionList(){
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          resetRouter()
          this.routerList=[]
          this.handlerRouters(res.data)
          this.routerList.forEach(item => {
            router.addRoute('index',item)
          })
          this.getRuleIds()
        }
      })
    },
    // 账号密码登录
    toPwdLogin() {
      this.$get(this.$api.login, {
        type: 'account',
        account: this.ruleForm.account,
        password: this.ruleForm.password,
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          this.$store.commit('saveShopData', res.data.shop)
          this.logining = false
          this.userData = res.data.user
          this.isLogin = true
          this.showPop = false
          if (res.data.user.last_time_shop_id > 0) {
            localStorage.setItem('ishavaStore', true)
            this.ishavaStore = true
            this.getPermissionList()
          } else {
            localStorage.setItem('ishavaStore', false)
            this.ishavaStore = false
            this.gochooseStore()
          }
        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    // 手机号登录
    toMobileLogin() {
      this.$get(this.$api.login, {
        type: 'mobile',
        mobile: this.ruleForm.mobile,
        code: this.ruleForm.code,
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          this.$store.commit('saveShopData', res.data.shop)
          this.logining = false
          this.userData = res.data.user
          this.isLogin = true
          this.showPop = false
          localStorage.setItem('ishavaStore', false)
          this.ishavaStore = false
          this.gochooseStore()
        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    // 注册
    toregister() {
      this.$post(this.$api.register, {
        mobile: this.ruleForm.mobile,
        code: this.ruleForm.code,
        password: this.ruleForm.pwd_r
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          // this.$store.commit('saveShopData', res.data.shop)
          this.logining = false
          this.userData = res.data.user
          this.isLogin = true
          this.showPop = false
          if (res.data.user.last_time_shop_id > 0) {
            localStorage.setItem('ishavaStore', true)
            this.ishavaStore = true
            this.getPermissionList()
          } else {
            localStorage.setItem('ishavaStore', false)
            this.ishavaStore = false
            this.gochooseStore()
          }
        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          if (this.status == 'accountLogin') {
            this.toPwdLogin()
          } else if (this.status == 'mobileLogin') {
            this.toMobileLogin()
          } else {
            this.toregister()
          }
        } else {
          this.logining = false
          return false
        }
      })
    },

  }
}
</script>

<style scoped>
.scroller {
  height:100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  transition: all 3s;
  scroll-behavior: smooth;
}

.scroller section {
  scroll-snap-align: start;
}

.top {
  width: 50px;
  height: 50px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  font-weight: bolder;
  cursor: pointer;
  border-radius: 50%;
  font-size: 30px;
  line-height: 50px;
  text-align: center;
}

.top:hover {
  background-color: #fff9b5;
}


.contact-us {
  width: 100px;
  height: 30px;
  background-color: white;
  margin: 20px auto;
  font-weight: bolder;
  cursor: pointer;
  box-shadow: 1px 1px 5px 1px #606060;
}

.contact-us:hover{
  background-color: rgb(240, 232, 232);
}

.contact {
  width: 100px;
  height: 200px;
  position: fixed;
  right: 30px;
  bottom: 300px;
  text-align: center;
  background-color: #fded40;
  border-radius: 50px 50px 0 0;
  z-index: 9999999999;
}

.btn {
  font-size: 16px;
  width: 165px;
  height: 50px;
  border-radius: 40px;
  border: 0;
  transition: all .5s;
  margin-left: 50px;
  color: white;
}

.btn:hover {
  cursor: pointer;
  opacity: .5;
}

.fl_3 {
  margin-left: 120px;
  color: white;
  width: 80px;
}

.fl_2 {
  color: #787878;
  width: 150px;
  text-align: center;
}


.fl_2 li {
  margin-top: 20px;
}

.fl_2 li:hover {
  color: #a0a0a0;
  cursor: pointer;
}

.fl_2 div {
  color: white;
  margin-bottom: 50px;
  width: 180px;
  text-align: center;
}

.jobox-joinus {
  position: absolute;
  top: 60px;
  right: 220px;
  width: 135px;
  height: 40px;
  border: 1px solid black;
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  transition: all .5s;
  cursor: pointer;
}

.jobox-joinus:hover {
  background-color: #fffcd2;
}

.btn-left,
.btn-right {
  border: none;
  width: 140px;
  height: 40px;
  text-align: center;
  border-radius: 20px;
  font-size: 16px;
}

.btn-left {
  background-color: #fde810;
}

.btn-right {
  background-color: #fffabe;
}

.btn-left:hover,
.btn-right:hover {
  opacity: .5;
  cursor: pointer;
}

.btn-left:active,
.btn-right:active {
  position: relative;
  top: 1px;
}


.img-box-two {
  margin-right: 120px;
  margin-top: 50px;
  width: 850px;
  height: 550px;
}


.all-li {
  width: 110px;
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  text-align: center;
  border: 2px solid #dbdede;
  margin: 15px;
  transition: all .5s;
}

.all-li:hover {
  background-color: #eaeaea;
  cursor: pointer;
}

.img-box {
  border-radius: 20px;
  border: 10px solid white;
  width: 600px;
  height: 400px;
  margin: 50px auto;
  overflow: hidden;
}

.big-img {
  width: 750px;
  height: 600px;
  background-position: center 200px;
  background-repeat: no-repeat;
  background-size: 100% 25%;
}

.all-img {
  width: 850px;
  height: 450px;
  border-radius: 10px;
}


.item-text {
  font-size: 15px;
  color: #b8b8b8;
  padding-left: 30px;
}

.drop-item {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  color: #000000;
  width: 275px;
  cursor: pointer;
  transition: all .3s;
  border-bottom: 1px solid #e9e9e9;
}

.drop-item:hover {
  color: #858585;
}


.outbox {
  min-height: 100vh;
  min-width: 1200px;
background-color: #fff;
  position: relative;
}

.hearder_out {
  background-color: #ffffff;
  min-width: 1200px;
  position: relative;
}

.hearder {
  margin: 0 auto;
  width: 1200px;
  height: 82px;
  display: flex;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
}

.reaster {
  width: 100%;
  height: 1000px;
  background-color: white;
}

.h_l {
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #000000;
  ;
  flex-wrap: wrap;
  width: 250px;

}

.h_l img {
  width: 46px;
  height: 46px;
  margin-right: 15px;
}

.h_r {
  display: flex;
  align-items: center;
}

.h_r span {
  font-size: 16px;
  color: #000000;
  margin-right: 55px;
  cursor: pointer;
}

.h_r .login {
  height: 50px;
  width: 90px;
  border: 1px solid #e9e9e9;
  box-shadow: 1px 1px 1px 1px #e9e9e9;
  border-radius: 40px;
  text-align: center;
  line-height: 50px;
}


.h_r .resgiter {
  width: 140px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  background: #FEE610;
  border-radius: 40px;
  font-size: 18px;
  color: #262732;
  cursor: pointer;
  transition: all .3s;
  margin-right: 22px;
}

.h_r div:active {
  transform: scale(.94);
  opacity: .9;
}

.out_tilte {
  font-size: 34px;
  color: #000000;
  text-align: center;
  padding: 80px 0 14px;
}

.out_tilte_s {
  font-size: 20px;
  color: #858585;
  text-align: center;
  padding-bottom: 85px;
}

.typebox {
  width: 1400px;
  margin: 0 auto 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.mb {
  margin-bottom: 110px;
}

.tb_once {
  width: 675px;
  height: 280px;
  padding: 0 40px;
  background: white;
  border-radius: 15px;
  box-shadow: 1px 1px 10px 1px #dbcfcf;
  cursor: pointer;
  transition: all .3s;
  margin-left: 22px;
}

.hr {
  border-bottom: 1px solid #dad3d3;
  padding: 20px 0;
}

.tb_once:hover {
  transform: scale(1.03);
}

.tb_once div {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #1F1F1F;
  padding-top: 20px;
}

.tb_once div img {
  width: 48px;
  height: 46px;
  margin-right: 18px;
}

.tb_once h1 {
  font-size: 18px;
  color: #444444;
  font-weight: normal;
  margin-top: 15px;
  margin-bottom: 20px;
}

.tb_once p {
  font-size: 16px;
  color: #7b7b7b;
  font-weight: normal;
  line-height: 26px;
  margin-bottom: 40px;
}

.hzbox {
  background: #e9ebf0;
  min-width: 1200px;
  padding-bottom: 80px;
}

.hzbox_inner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.hzbox_inner img {
  width: 234px;
  margin-right: 88px;
  margin-bottom: 70px;
}

.hzbox_inner img:nth-child(4n) {
  margin-right: 0;
}

.joinbox {
  background: #FEE610;
  min-width: 1200px;
  display: flex;
  position: relative;
}

.joinbox_inner {
  width: 1200px;
  margin: 0 auto;
}

.joinbox_inner h1 {
  font-size: 26px;
  color: #000000;
  font-weight: 500;
  padding: 30px 0 10px;
  margin: 0;
}

.joinbox_inner p {
  font-size: 16px;
  color: #000000;
  padding-bottom: 30px;
  margin: 0;
}

.footer {
  background: #212121;
  min-width: 1200px;
  position: relative;
  height: 350px;
}

.footer_inner {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
}

.fl_1 div {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 36px;
}

.fl_1 div:first-child {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #FFFFFF;
  margin-bottom: 58px;
}

.fl_1 div:first-child img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.login-wrap_out {
  width: 0;
  height: 0;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  overflow: hidden;
  transition: all .5s;
}

.login-wrap_out_c {
  width: 100vw;
  height: 100vh;
}

.login-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  width: 350px;
}

.el-icon-close {
  font-size: 26px;
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.el-icon-close:hover {
  cursor: pointer;
  color: #ffaf36;
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.happy {
  position: fixed;
  top: 50px;
  right: 50px;
  font-size: 16px;
  color: white;
  font-family: cursive;
  user-select: none;
}

.formCls {
  position: relative;
  opacity: 0;
  top: 50px;
  transition: all .2s;
}

.formCls_o {
  top: 0;
  opacity: 1;
}

>>>.el-carousel__button {
  background: gray;
  height: 4px;
}

>>>.el-carousel__indicator.is-active button {
  background: #ffaf36;
}

>>>.el-button--primary {
  background: #ffaf36;
  border-color: #ffaf36;
}

>>>.el-tabs__item.is-active {
  color: #ffaf36;
}

>>>.el-tabs__active-bar {
  background: #ffaf36;
}

>>>.el-tabs__item:hover {
  color: #ffaf36;
}

>>>.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border: none;
}


>>>.custom-tabs .el-tabs__item.is-active {
  color: black;
}

>>>.custom-tabs .el-tabs__active-bar {
  background: black;
}

>>>.custom-tabs .el-tabs__item {
  color: #9fa4a3;
  font-size: 17px;
  height: 50px;
  padding-right: 50px;
  text-align: center;
  padding-left: 350px;
  font-weight: 100;
}

.custom-tabs-parent {
  display: flex;
  justify-content: center;
}

/* 确保整个 el-tabs 容器使用 Flexbox */
.custom-tabs {
  display: flex;
  flex-direction: column;
}

.all-tabs-parent {
  display: flex;
  justify-content: center;
  /* 这将使 custom-tabs 在其父元素中水平居中 */
  width: 1525px;
  background-color: #f4f7f9;
  height: 40px;
  border-radius: 25px;
  margin: 0 auto;
  color: black;
}

>>>.all-tabs .el-tabs__item.is-active {
  border: 1px solid #e2e5e5;
  color: black;
  border-radius: 40px;
  background-color: white;
  box-shadow: 1px 1px 10px 5px #e7eaec;

}

>>>.all-tabs .el-tabs__active-bar {
  background-color: #f4f7f9;

}

>>>.all-tabs .el-tabs__item {
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #9da0a2;

}
</style>



// WEBPACK FOOTER //
// src/views/login.vue